export { default as SearchInput } from './src/SearchInput'
